<template>
    <div>
        <div class="card" v-if="$route.query.type !== 'add'">
            <ul>
                <li v-for="(item,index) of data" :key="index">
                    <div class="upper"><p>{{item.name}}</p></div>
                    <div class="lower">
                        <span>{{item.price}}</span>
                        <button @click="submit">立即使用</button>
                    </div>
                </li>
            </ul>
            <div class="add"><button @click="add">+添加新的福利</button></div>
        </div>

        <addwelfare v-if="$route.query.type === 'add'"></addwelfare>
    </div>
</template>
<script>
import { addwelfare } from './component'
export default {
    components:{
        addwelfare,
    },
    data() {
        return{
            data:[
                    {id:1,name:'光大银行员工福利',price:1000},
                    {id:2,name:'光大银行员工福利',price:1000},
                    {id:3,name:'光大银行员工福利',price:1000},
                    {id:4,name:'光大银行员工福利',price:1000},
                ],
            
        }
    },
    methods:{
        submit(id){
            console.log(id)
        },
        add(){
            this.$router.push({
                name:this.$route.name,
                query:{type:"add"}
            })
            this.$router.go()
        }
    }
}
</script>
<style lang="scss" scoped>
    .card{
        font-size: 0.36rem;
        ul{
            li{
                color: #FF6161;
                width: 7.18rem;
                height: 3.6rem;
                background: url('../../assets/bg/welfare.png') no-repeat;
                background-size:7.18rem 3.6rem;
                position: relative;
                margin: auto;
                .upper{
                    position: relative;
                    top: 0.5rem;
                    left: 0.5rem;
                    width: 6rem;

                }
                .lower{
                    position: absolute;
                    bottom: 0.5rem;
                    padding: 0 0.5rem;
                    width: 6rem;
                    @include flexBox(space-between);
                    button{
                        background: none;
                        border: none;
                    }
                }
            }
        }
    }
    .add{
        font-size: 0.32rem;
        position: fixed;
        width: 100%;
        bottom: 0.7rem;
        button{
            @include btn(#FF6161,.86rem);
            width:7.18rem;
        }
    }
</style>